export const getFocusPosition = (array: Array<string>): number => {
  const position = array.findIndex((state) => state === '');

  return position > -1 ? position : array.length;
};

export const padEnd = (array: string[], minLength: number): string[] => {
  return Object.assign(new Array(minLength).fill(''), array);
};
